// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rnwv","colMin":"styles_colMin__Wfhbc"};